<script>
import * as constants from '@/utilities/appConsts'
import variables from '@/styles/_varsJs.scss'

export default {
  props: {
    status: {
      type: String,
      default: constants.STATUS_VALUES.normal,
      validator: val =>
        [
          constants.STATUS_VALUES.normal,
          constants.STATUS_VALUES.computed,
          constants.STATUS_VALUES.lowWarning,
          constants.STATUS_VALUES.lowCaution,
          constants.STATUS_VALUES.highCaution,
          constants.STATUS_VALUES.highWarning,
          constants.STATUS_VALUES.faultMonitor,
          constants.STATUS_VALUES.highLowWarning,
          constants.STATUS_VALUES.highLowCaution,
          constants.STATUS_VALUES.eventWarning,
          constants.STATUS_VALUES.eventCaution,
          '',
        ].includes(val),
    },
    count: {
      type: [String, Number],
      default: 0,
    },
  },

  computed: {
    getAlertText() {
      if (this.status === constants.STATUS_VALUES.lowWarning) {
        return this.simple
          ? `${constants.STATUS_TITLES.lowWarning}`
          : `${constants.PARAMETER} ${constants.STATUS_TITLES.lowWarning}`
      }
      if (this.status === constants.STATUS_VALUES.lowCaution) {
        return this.simple
          ? `${constants.STATUS_TITLES.lowCaution}`
          : `${constants.PARAMETER} ${constants.STATUS_TITLES.lowCaution}`
      }
      if (this.status === constants.STATUS_VALUES.highCaution) {
        return this.simple
          ? `${constants.STATUS_TITLES.highCaution}`
          : `${constants.PARAMETER} ${constants.STATUS_TITLES.highCaution}`
      }
      if (this.status === constants.STATUS_VALUES.highWarning) {
        return this.simple
          ? `${constants.STATUS_TITLES.highWarning}`
          : `${constants.PARAMETER} ${constants.STATUS_TITLES.highWarning}`
      }
      return constants.NO_PARAMETER_ALERT
    },
    isDown() {
      return (
        this.status === constants.STATUS_VALUES.lowWarning ||
        this.status === constants.STATUS_VALUES.lowCaution
      )
    },
    isUp() {
      return (
        this.status === constants.STATUS_VALUES.highWarning ||
        this.status === constants.STATUS_VALUES.highCaution
      )
    },
    isUpDown() {
      return (
        this.status === constants.STATUS_VALUES.highLowWarning ||
        this.status === constants.STATUS_VALUES.highLowCaution
      )
    },
    isSquare() {
      return (
        this.status === constants.STATUS_VALUES.eventWarning ||
        this.status === constants.STATUS_VALUES.eventCaution
      )
    },
    isCircle() {
      return this.status === constants.STATUS_VALUES.faultMonitor
    },
    getBgColor() {
      if (
        this.status === constants.STATUS_VALUES.lowCaution ||
        this.status === constants.STATUS_VALUES.highCaution ||
        this.status === constants.STATUS_VALUES.highLowCaution ||
        this.status === constants.STATUS_VALUES.eventCaution
      ) {
        return variables.cautionbase
      }
      if (
        this.status === constants.STATUS_VALUES.lowWarning ||
        this.status === constants.STATUS_VALUES.highWarning ||
        this.status === constants.STATUS_VALUES.highLowWarning ||
        this.status === constants.STATUS_VALUES.eventWarning
      ) {
        return variables.warningbase
      }
      if (this.status === constants.STATUS_VALUES.faultMonitor) {
        return variables.gray700
      }
      return variables.primarywhite
    },
    getBgColor1() {
      if (
        this.status === constants.STATUS_VALUES.lowCaution ||
        this.status === constants.STATUS_VALUES.highCaution ||
        this.status === constants.STATUS_VALUES.highLowCaution ||
        this.status === constants.STATUS_VALUES.eventCaution
      ) {
        return variables.cautiondarken1
      }
      if (
        this.status === constants.STATUS_VALUES.lowWarning ||
        this.status === constants.STATUS_VALUES.highWarning ||
        this.status === constants.STATUS_VALUES.highLowWarning ||
        this.status === constants.STATUS_VALUES.eventWarning
      ) {
        return variables.warningdarken1
      }
      if (this.status === constants.STATUS_VALUES.faultMonitor) {
        return variables.primaryblack
      }
      return variables.primarywhite
    },
    getColor() {
      if (
        this.status === constants.STATUS_VALUES.lowWarning ||
        this.status === constants.STATUS_VALUES.highWarning ||
        this.status === constants.STATUS_VALUES.lowCaution ||
        this.status === constants.STATUS_VALUES.highCaution ||
        this.status === constants.STATUS_VALUES.faultMonitor ||
        this.status === constants.STATUS_VALUES.highLowWarning ||
        this.status === constants.STATUS_VALUES.eventWarning
      ) {
        return variables.primarywhite
      }
      return variables.primaryblack
    },
    hasParameterAlert() {
      return (
        this.status !== constants.STATUS_VALUES.normal &&
        this.status !== constants.STATUS_VALUES.faultMonitor &&
        this.alertEnabled !== false
      )
    },
    hasFaultMonitorAlert() {
      return this.status === constants.STATUS_VALUES.faultMonitor
    },
  },
}
</script>
